/**
 * Sets header height to root property
 * Uses requestAnimationFrame to prevent forced reflows
 **/
let rafId = null;

const setHeaderHeight = () => {
	const root = document.documentElement;
	const header = document.querySelector('header');

	if (!root || !header) {
		return;
	}

	// Cancel any pending updates
	if (rafId) {
		cancelAnimationFrame(rafId);
	}

	// Batch DOM read and write in requestAnimationFrame to prevent forced reflows
	rafId = requestAnimationFrame(() => {
		const height = Math.round(header.getBoundingClientRect().height);
		root.style.setProperty('--header-height', `${height}px`);
		rafId = null;
	});
};

const initHeaderHeight = () => {
	const updateHeight = () => {
		setHeaderHeight();
	};

	// Wait for fonts to load before measuring to prevent forced reflow
	if (document.fonts && document.fonts.ready) {
		document.fonts.ready.then(updateHeight).catch(() => {});
	} else {
		// If fonts API not available, use load event
		window.addEventListener('load', updateHeight, { once: true });
	}

	window.addEventListener('resize', updateHeight);
	
	// Defer initial call to prevent forced reflow during page load
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', updateHeight, { once: true });
	} else {
		updateHeight();
	}
};

const markSliderReady = (slider) => {
	if (!slider.classList.contains('uk-slider-ready')) {
		slider.classList.add('uk-slider-ready');
	}
};

const initSliders = () => {
	const bootstrap = () => {
		const sliders = document.querySelectorAll('.uk-slider');
		if (!sliders.length) {
			return;
		}

		sliders.forEach((slider) => {
			if (window.UIkit && window.UIkit.getComponent) {
				const sliderComponent = window.UIkit.getComponent(slider, 'slider');
				if (sliderComponent) {
					markSliderReady(slider);
					window.UIkit.util.on(slider, 'itemshown', () => markSliderReady(slider));
					return;
				}
			}

			// UIkit not available yet; mark as ready so layout is stable
			markSliderReady(slider);
		});
	};

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', bootstrap, { once: true });
	} else {
		bootstrap();
	}
};

const normalizeInstagramLinks = () => {
	const anchors = document.querySelectorAll('a[href^="intent://instagram.com/_u/"]');
	anchors.forEach((anchor) => {
		const original = anchor.getAttribute('href');
		if (!original) {
			return;
		}

		const match = original.match(/intent:\/\/instagram\.com\/_u\/([^?]+)/i);
		if (match && match[1]) {
			const handle = decodeURIComponent(match[1]);
			anchor.setAttribute('href', `https://www.instagram.com/${handle.replace(/\/$/, '')}/`);
			anchor.setAttribute('target', '_blank');
			anchor.setAttribute('rel', 'noopener noreferrer');
		}
	});
};

const initInstagramLinks = () => {
	normalizeInstagramLinks();

	const observer = new MutationObserver(() => normalizeInstagramLinks());
	observer.observe(document.body, { childList: true, subtree: true });
};

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', initHeaderHeight, { once: true });
	document.addEventListener('DOMContentLoaded', initInstagramLinks, { once: true });
} else {
	initHeaderHeight();
	initInstagramLinks();
}

initSliders();
